"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Radar2 = _interopRequireDefault(require("./Radar"));

var PIXI = _interopRequireWildcard(require("pixi.js-legacy"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var SCALE_STEP = 40;
var fieldFill = 0x000000; // 'rgba(0,0,0,0.3)'

var fieldStroke = 0xebebeb;

var BaseballRadar = /*#__PURE__*/function (_Radar) {
  _inherits(BaseballRadar, _Radar);

  var _super = _createSuper(BaseballRadar);

  function BaseballRadar() {
    var _this;

    _classCallCheck(this, BaseballRadar);

    _this = _super.call(this);
    _this._name = "Radar";
    _this.sport = "baseball";
    return _this;
  } //// Updates


  _createClass(BaseballRadar, [{
    key: "updateField",
    value: function updateField(toFrame) {
      var frame = toFrame;
      var fromFrame = this.fieldFrame;

      if (fromFrame.w !== toFrame.w && fromFrame.w !== 1) {
        var dist = this.distance(fromFrame, toFrame);
        var wDiff = Math.abs(fromFrame.w - toFrame.w);
        var scaleSteps = wDiff / SCALE_STEP;
        var pt = this.stepPoint(fromFrame, toFrame, dist / scaleSteps);
        var w = this.stepValue(fromFrame.w, toFrame.w, SCALE_STEP);
        var h = w / toFrame.w * toFrame.h;
        frame = this.makeRect(pt.x, pt.y, w, h);
      }

      this.fieldFrame = frame;
      this.field.x = frame.x;
      this.field.y = frame.y;
      var scale = frame.w / this.origFieldWidth;
      this.field.setTransform(frame.x, frame.y, scale, scale); //this.field.

      this.closeButton.x = frame.x + frame.w + 20;
      this.closeButton.y = frame.y - 20;
      this.closeButton.alpha = this.mini ? 0 : 1;

      if (this.mouseOver) {
        document.body.style.cursor = "pointer";
      } else {
        document.body.style.cursor = "default";
      }
    } //// Shape Generation

  }, {
    key: "generateField",
    value: function generateField(frame, fieldData) {
      var lw = frame.w * 0.011; // const baseSize = frame.w * 0.025

      var ptHome = {
        x: frame.center.x,
        y: frame.max.y
      };
      var sideLength = frame.h;
      var right_baseline_ratio = fieldData.baseline_length / fieldData.right_foul_length;
      var baseline_length = sideLength * right_baseline_ratio;
      var ptRightFence = this.pointAtAngle(ptHome, -45, sideLength);
      var ptLeftFence = this.pointAtAngle(ptHome, -135, sideLength);
      var ptFirst = this.pointAtAngle(ptHome, -45, baseline_length);
      var ptSecond = this.pointAtAngle(ptFirst, -135, baseline_length);
      var ptThird = this.pointAtAngle(ptSecond, -225, baseline_length);
      var field = new PIXI.Graphics(); // Field background / boundary

      field.beginFill(fieldFill, 0.3);
      field.moveTo(ptHome.x, ptHome.y);
      field.lineTo(ptLeftFence.x, ptLeftFence.y);
      field.arc(ptHome.x, ptHome.y, frame.h, -135 * (Math.PI / 180), -45 * (Math.PI / 180), false);
      field.lineTo(ptHome.x, ptHome.y);
      field.endFill();
      field.lineStyle(lw, fieldStroke, 0.5, 0.5);
      field.moveTo(ptHome.x, ptHome.y);
      field.lineTo(ptRightFence.x, ptRightFence.y);
      field.moveTo(ptHome.x, ptHome.y);
      field.lineTo(ptLeftFence.x, ptLeftFence.y);
      field.moveTo(ptFirst.x, ptFirst.y);
      field.lineTo(ptSecond.x, ptSecond.y);
      field.lineTo(ptThird.x, ptThird.y);
      return field;
    }
  }]);

  return BaseballRadar;
}(_Radar2.default);

exports.default = BaseballRadar;